var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { Text } from '../text';
import Ribbon from './ribbon';
import { badgeStyle, innerContentStaticStyle, sizeMap, wrapperStaticStyle, } from './styles';
function renderIcon(decor, size) {
    // Check if the Icon has a provided custom size prop already
    return decor.props.size != null
        ? decor
        : cloneElement(decor, {
            size: sizeMap[size].iconSize,
            style: { flexShrink: 0 },
        });
}
function Badge(_a) {
    var { children, decor, mode = 'regular', size = 'medium', type = 'regular', variant = 'navy' } = _a, restProps = __rest(_a, ["children", "decor", "mode", "size", "type", "variant"]);
    return (_jsxs(Text, Object.assign({ css: badgeStyle({ mode, size, type, variant }) }, restProps, { children: [_jsxs("span", Object.assign({ css: wrapperStaticStyle }, { children: [decor !== undefined && renderIcon(decor, size), _jsx("span", Object.assign({ css: innerContentStaticStyle }, { children: children }))] })), type === 'ribbon' && _jsx(Ribbon, { size: size })] })));
}
export default Badge;
